// Open someone's conversation in Phone & Messages from anywhere in the console (driver profiles, employees, …).
// The tab follows the address (?tab=phone); the conversation waits here until Phone & Messages picks it up.
let pending = null;
export function openConversation(phone) {
  const d = String(phone || '').replace(/\D/g, '').slice(-10);
  if (d.length !== 10) return false;
  pending = `p:${d}`;
  if (`${window.location.pathname}${window.location.search}` !== '/truckmate?tab=phone') {
    window.history.pushState({}, '', '/truckmate?tab=phone');
    window.dispatchEvent(new PopStateEvent('popstate'));   // the router reads the new address
  }
  window.dispatchEvent(new CustomEvent('dd-open-conversation', { detail: pending }));
  return true;
}
export const takeConversation = () => { const p = pending; pending = null; return p; };
